import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-pending",
  "use": "icon-pending-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 10 10\" id=\"icon-pending\"><circle cx=\"5\" cy=\"5\" r=\"4.5\" stroke=\"#F7A600\" /><path stroke=\"#F7A600\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6.656 6.02 5 5V3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol